import {useDispatch} from 'react-redux';
import type {AppDispatch} from '../state/store';

export default function useTypedDispatch() {
  return useDispatch<AppDispatch>();
}
